import React from 'react';
import { ArrowDown } from '@fabric-ui/icons';
import { noop } from '@fabric-ui/utils';
import { Box, IconButton, SxProps } from '@mui/material';

const expandIcon = <ArrowDown />;

interface ExpandButtonProps {
  value?: boolean;
  onChange?(val: boolean): unknown;
  disabled?: boolean;
  style?: SxProps;
  label?: React.ReactNode;
}

export function ExpandButton({ value = false, onChange = noop, disabled = false, style = {}, label }: ExpandButtonProps) {
  return (
    <>
      <IconButton
        disabled={disabled}
        sx={{
          svg: {
            rotate: value ? null : '-90deg',
            transition: ({ transitions }) => transitions.create(['rotate'], { duration: transitions.duration.short }),
          },
          ...style,
        }}
        onClick={() => onChange(!value)}>
        {expandIcon}
      </IconButton>
      {label && (
        <Box sx={{ cursor: 'pointer' }} onClick={() => onChange(!value)}>
          {label}
        </Box>
      )}
    </>
  );
}
